import { Box, Flex, Text, Tooltip, VStack } from "@reverb-ui/react";
import InformationMessage from "./InformationMessage";
import { HeaderCard } from "./HeaderCard";

export type TTopFiveProps = {
  title: string,
  iconName: string;
  data?: {
    name: string;
    value: string;
  }[];
};

export const TopFive = ({
  title,
  iconName,
  data
}: TTopFiveProps) => {
  return (
    <Box bg="white" w="full" h="full" display={'flex'} flexDirection="column" p={6} minHeight={"330"}>
      <VStack alignItems="start" spacing={5} w="full">
        <HeaderCard title={title} iconName={iconName}/>
        <Flex w="full" justifyContent="space-between">
          <Text color="gray.500" fontWeight="semibold" fontSize="xs">NAME</Text>
          <Text color="gray.500" fontWeight="semibold" fontSize="xs">TRAFFIC</Text>
        </Flex>
        {data?.map((item, index) => (
          <Flex w="full" justifyContent="space-between" key={index}>
            <Tooltip label={item.name} placement="bottom" bg="gray.100" color="gray.800">
              <Text color="gray.700" maxWidth={"85%"} isTruncated={true} fontSize="sm">{item.name}</Text>
            </Tooltip>
            <Text color="gray.700" fontWeight="semibold" fontSize="sm">{item.value}</Text>
          </Flex>
        ))}
      </VStack>
      {(data == null || data.length < 5) && (
        <Flex justifyContent="flex-end" mt={"auto"}>
          <InformationMessage messageText={"There aren't 5 records to show yet."}/>
        </Flex>
      )}
    </Box>
  );
};
